<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 统计报表
                </el-breadcrumb-item>
				<el-breadcrumb-item>报价统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.id" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:8+'px'}"
				stripe
            >	
				<el-table-column type="expand">
					<template slot-scope="child">
						<table style="width:100%">
							<tr><th style="padding-left:10px;" v-for="(item, index) in child.row.planByTypes">{{item.typeName}}</th></tr>
							<tr><td style="padding-left:10px;" v-for="(item, index) in child.row.planByTypes">{{item.planNum}}</td></tr>
						</table>
					</template>
				</el-table-column>
                <el-table-column prop="channelName" label="渠道名称"></el-table-column>
				<el-table-column prop="planTotal" label="备货型号数量"></el-table-column>
				<el-table-column prop="offerTotal" label="报价型号数量"></el-table-column>
				<el-table-column prop="superiorityTotal" label="优势报价型号数量"></el-table-column>
				<el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if = "controll['show']"
                        >优势型号</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="优势型号" :visible.sync="previewVisible" width="60%">
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="typeSeriesRemark" label="产品系列"></el-table-column>
				<el-table-column prop="productName" label="产品名称" width="200px"></el-table-column>
				<el-table-column prop="newestPrice" label="最新报价" width="150px"></el-table-column>
				<el-table-column prop="newestPriceTime" label="最新报价时间" width="160px"></el-table-column>
				<el-table-column prop="rowNo" label="排名" width="100px"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getOfferStatPages, getChannelKV } from '../../../api/index';
export default {
    name: 'offer-total',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
            form: {},
            idx: -1,
			title:"",
			channelsKV:[],
			previewVisible:false,
			previewData:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("offer-total");
		this.getChannels();
        this.getData();
    },
    methods: {
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelsKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            getOfferStatPages(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleShow(index, row) {
			this.previewData = row.superiorityOffers;
			this.previewVisible = true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
